<div class="root">
  <skypro-message-attachment-preview
    [url]="attachment.url ?? attachment.previewUrl"
    [type]="attachment.type"
    [title]="attachment.title"
  >
    <div class="wrapper-inner" [class.-upload-blur]="!attachment.url">
      <div class="upload-progress-bar">
        @if (!attachment.url) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          version="1.1"
          viewBox="0 0 40 40"
          preserveAspectRatio="xMidYMid meet"
          role="progressbar"
        >
          <circle cx="20" cy="20" r="18" class="upload-progress-bar-inner"></circle>
          <circle #progressCircle cx="20" cy="20" r="18" class="upload-progress-bar-outer"></circle>
        </svg>
        } @if (!attachment.url) {
        <div (click)="remove()" class="cancel-upload">
          <ds-icon [svgContent]="icons.cancelUpload"></ds-icon>
        </div>
        } @if (attachment.status === attachmentStatus.error) {
        <ds-icon
          [svgContent]="icons.uploadError"
          dsTooltip="{{ 'skyproLibMessages.uploadError' | transloco }}"
          class="upload-error-icon"
          (click)="remove()"
        ></ds-icon>
        }
      </div>
    </div>
  </skypro-message-attachment-preview>
  <div class="corner">
    @if (attachment.url) {
    <button class="close-button" (click)="remove()"></button>
    }
  </div>
</div>
